<template>
    <div>
        <div style="font-weight: bold;font-size: 18px">手动对账</div>
        <br>

        <el-form label-width="150px">
            <el-form-item label="对账类别">
                <el-select v-model="manualParams.category">
                    <el-option v-for="item in categoryTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="用户ID">
                <el-input v-model="manualParams.userId"></el-input>
            </el-form-item>
            <el-form-item label="对账左类型">
                <el-select v-model="manualParams.leftType">
                    <el-option v-for="item in reconciliationType" :key="item.code" :label="item.desc" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="对账右类型">
                <el-select v-model="manualParams.rightType">
                    <el-option v-for="item in reconciliationType" :key="item.code" :label="item.desc" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="对账目标（币种）">
                <el-input v-model="manualParams.target"></el-input>
            </el-form-item>
            <el-form-item label="对账时间">
                <el-date-picker v-model="datePicker" type="datetimerange" range-separator="至" start-placeholder="对账开始时间" end-placeholder="对账结束时间" value-format="timestamp"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitManual()">手动对账</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "manualReconciliation",
        data(){
            return {
                categoryTypes:[{code:'TOTAL',desc:'总数'},{code:'USER_PLATFORM',desc:'用户与平台'}],
                manualParams:{
                    category:'',
                    target:'',
                    leftType:'',
                    rightType:'',
                    userId: '',
                    start:'',
                    end:'',
                },
                reconciliationType:[{code:'ACCOUNT',desc:'账务记录'},{code:'BALANCE',desc:'余额'}],//{code:'EVIDENCE',desc:'业务记录'},
                datePicker:[]
            }
        },
        methods:{
            submitManual(){
                this.manualParams.start = this.datePicker[0];
                this.manualParams.end = this.datePicker[1];
                api.reconciliationManual(this.manualParams).then(response =>{
                    let result = response.data.result;
                    let detail = response.data.detail;
                    if (result === 0) {
                        this.$message.success('成功[' + result + '],详情:' + detail);
                    }else {
                        this.$message.error('失败[' + result + '],详情:' + detail);
                    }

                })
            }
        }
    }
</script>

<style scoped>

</style>
